import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SroServices from '../../services/SroServices.js';
import StateServices from '../../services/StateServices.js';
import Select from 'react-select';

function UpdateDistrict({ selectedData, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        district: null,
        districtCode: '',
        srocode: '',
        sronameeng: '',
    });
    const [districts, setDistricts] = useState([]);

    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                const res = await StateServices.getAllDistrict();
                console.log(res);
                if (res.status === true) {
                    const districtOptions = res.data.map(district => ({
                        label: district.name,
                        value: district._id,
                        districtCode: district.districtCode, // include districtCode
                    }));
                    setDistricts(districtOptions);
                } else {
                    alert('Failed to fetch district');
                }
            } catch (error) {
                console.error('Failed to fetch district', error);
                alert('Failed to fetch district');
            }
        };

        fetchDistricts();
    }, []);

    useEffect(() => {
        if (selectedData) {
            setFormValues({
                district: districts.find(d => d.value === selectedData.district._id) || '', // Adjust this line to find the selected district
                districtCode: selectedData.districtCode || '',
                srocode: selectedData.srocode || '',
                sronameeng: selectedData.sronameeng || '',
            });
        }
    }, [selectedData, districts]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: name === 'name' ? value.toUpperCase() : value,
        });
    };

    const handleSelectChange = (selectedOption) => {
        setFormValues({
            ...formValues,
            district: selectedOption,
            districtCode: selectedOption?.districtCode || '', // auto-fill districtCode
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const res = await StateServices.updateThana(selectedData._id, {
                districtCode: formValues.districtCode,
                district: formValues.district.value, // send district ID
                srocode: formValues.srocode,
                sronameeng: formValues.sronameeng
            });
            if (res.status === true) {
                alert('SRO updated successfully');
                onSuccess();
                closeModal();
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            console.error('Failed to update sro', error);
            alert(error.response?.data?.message || 'Failed to update sro');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit SRO</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body px-5 pb-0">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className="input-field">
                                            <label>District Name*</label>
                                            <Select
                                                name="district"
                                                className="form-control"
                                                value={formValues.district}
                                                onChange={handleSelectChange}
                                                options={districts}
                                                placeholder="Select a District"
                                                isSearchable
                                                required
                                            />
                                        </div>
                                        <div className="input-field">
                                            <label>District Code*</label>
                                            <input
                                                type="text"
                                                name="districtCode"
                                                className="form-control"
                                                value={formValues.districtCode}
                                                onChange={handleInputChange}
                                                readOnly
                                                required
                                            />
                                        </div>
                                        <div className="input-field">
                                            <label>SRO Code</label>
                                            <input
                                                type="text"
                                                name="srocode"
                                                className="form-control"
                                                value={formValues.srocode}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="input-field">
                                            <label>SRO Name (English)</label>
                                            <input
                                                type="text"
                                                name="sronameeng"
                                                className="form-control"
                                                value={formValues.sronameeng}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <button className="submit-green-btn" type="submit">
                                            SUBMIT
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

UpdateDistrict.propTypes = {
    selectedData: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default UpdateDistrict;
